const slider_config_type = {
    1: {
        slidesPerView:  "auto",
        spaceBetween: 20,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 160,
        centeredSlides: true,
        initialSlide:3,
        loop:true
    },
    2: {
        slidesPerView:  5.2,
        spaceBetween: 40,
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
        breakpoints: {
            '1': {
                slidesPerView: 2,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                spaceBetween: 10,
            },
            '300': {
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                slidesPerView: 1.3,
                spaceBetween: 20,
            },
            '500': {
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                slidesPerView: 1.5,
                spaceBetween: 20,
            },
            '768': {
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                slidesPerView: 3.2,
                spaceBetween: 20,
            },
            '1023': {
                slidesPerView: 4.2,
                spaceBetween: 20,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
            },
            '1440': {
                slidesPerView: 5.16,
                spaceBetween: 40,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48,
            },
        }
    },
    3: {
        slidesPerView:  1,
        watchSlidesProgress: true,
    }, 
    4: {
        slidesPerView:  4.45,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        spaceBetween: 12,
         breakpoints: {
            '1': {
                slidesPerView:  1.45,
            },
            '320': {
                slidesPerView:  2.25,
            },
            '500': {
                slidesPerView:  2.45,
            },
            '768': {
                slidesPerView:  4.45,
            }
        }
    }
}

// class CustomSlider extends HTMLElement {
//   connectedCallback() {
//     this.index = this.dataset.index || 1;

//     const isThumb = this.classList.contains('swiper-thumb');
//     const noNavigation = this.hasAttribute('data-no-navigation') || isThumb;

//     const nextEl = !noNavigation
//       ? this.querySelector(".swiper-button-next") || this.closest('.shopify-section')?.querySelector(".swiper-button-next")
//       : null;

//     const prevEl = !noNavigation
//       ? this.querySelector(".swiper-button-prev") || this.closest('.shopify-section')?.querySelector(".swiper-button-prev")
//       : null;

//     this.navigation = nextEl && prevEl
//       ? {
//           navigation: {
//             nextEl,
//             prevEl,
//           },
//         }
//       : {};

//     this.config = {
//       ...slider_config_type[this.index],
//       ...this.navigation,
//       observer: true,
//       observeParents: true,
//     };

//     this.swiper = new Swiper(this, this.config);

//     if (this.classList.contains('swiper-main-thumb')) {
//       this.initThumbSlider();
//     }
//   }

//   initThumbSlider() {
//     const thumbSlider = this.closest('.section-thumbnail-slider__wrap')?.querySelector('custom-slider.swiper-thumb');
//     this.checkThumbSlider(thumbSlider);
//   }

//   checkThumbSlider(thumbSlider) {
//     const thumbSwiper = thumbSlider?.swiper;

//     if (!thumbSwiper) {
//       setTimeout(() => this.checkThumbSlider(thumbSlider), 100);
//       return;
//     }

//     const activeClass = 'swiper-slide-thumb-active';

//     const updateThumb = () => {
//       const index = this.swiper.realIndex ?? this.swiper.activeIndex;

//       thumbSwiper.slides.forEach((slide, slideIndex) => {
//         slide.classList.toggle(activeClass, slideIndex === index);
//       });
//     };

//     updateThumb();

//     this.swiper.on('slideChange', updateThumb);
//     this.swiper.on('activeIndexChange', updateThumb);
//     this.swiper.on('transitionEnd', updateThumb);

//     thumbSwiper.slides.forEach((slide, index) => {
//       slide.addEventListener('click', () => {
//         this.swiper.slideTo(index);
//         updateThumb();
//       });
//     });
//   }
// }

// customElements.define('custom-slider', CustomSlider);
class CustomSlider extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    this.index = this.dataset.index || 1;

    const isThumb = this.classList.contains('swiper-thumb');
    const noNavigation = this.hasAttribute('data-no-navigation') || isThumb;

    const nextEl = !noNavigation
      ? this.querySelector(".swiper-button-next") || this.closest('.shopify-section')?.querySelector(".swiper-button-next")
      : null;

    const prevEl = !noNavigation
      ? this.querySelector(".swiper-button-prev") || this.closest('.shopify-section')?.querySelector(".swiper-button-prev")
      : null;

    const navigation = nextEl && prevEl
      ? {
          navigation: {
            nextEl,
            prevEl,
          },
        }
      : {};

    this.config = {
      ...slider_config_type[this.index],
      ...navigation,
      observer: true,
      observeParents: true,
    };

    if (this.classList.contains('swiper-main-thumb')) {
      this.initMainWithThumbs();
      return;
    }

    this.swiper = new Swiper(this, this.config);
  }

  initMainWithThumbs() {
    const section = this.closest('.section-thumbnail-slider__wrap') || this.closest('.shopify-section');
    const thumbSlider = section?.querySelector('custom-slider.swiper-thumb');

    if (!thumbSlider) {
      this.swiper = new Swiper(this, this.config);
      return;
    }

    const init = () => {
      if (!thumbSlider.swiper) {
        requestAnimationFrame(init);
        return;
      }

      this.swiper = new Swiper(this, {
        ...this.config,
        thumbs: {
          swiper: thumbSlider.swiper,
          autoScrollOffset: 1,
        },
      });
    };

    init();
  }
  updateSlider() {
      if (!this.swiper) return;

      this.swiper.update();

      if (this.swiper2) {
        this.swiper2.update();
      }
  }
}

customElements.define('custom-slider', CustomSlider);